interface Truncate {
  length: number
  end: string
}

export function truncate(str?: string, opt?: Truncate): string {
  if (!str) return ''
  const { length, end } = opt || { length: 14, end: '...' }

  if (str.length <= length) return str

  return str.slice(0, length - end.length) + end
}
